import type { FaireProductEntity } from "../../entity_types/product";

export const p_bh53pn83mx: FaireProductEntity = {
  token: "p_bh53pn83mx",
  type: "product",
  name: "LONG SLEEVE ROUND NECK STRIPED BUTTON UP TOP",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/dc99faf00d0b69d70f8212e2383c7d2591c250dc9233c0e16fe15d66b187f154.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/db89b60ab8468a1a8113d513039172fdc2bb6864f295662d66fc397f4ddc7941.jpeg",
    "https://cdn.faire.com/fastly/6bbd429aefac4d196b68d568225681cae94260f01ced8aff004d4e8fff4c329a.jpeg",
    "https://cdn.faire.com/fastly/900164dd34333a2b21cfdb35ceb1d0ce8e6caa23379b4c72a311d87e5cdb0fa3.jpeg",
    "https://cdn.faire.com/fastly/91862145bd25a38a32281d22fd1591436ac2d117fff928efa4b2c09e5cca69d3.jpeg",
    "https://cdn.faire.com/fastly/b48b83c7d40dbfcae80e63183bd72901ceda86c374cd8978f449c11c7130bf2a.jpeg",
  ],
  priceDollars: 162,
  description:
    '**TOP ONLY**\n\n(MATCHING SET WITH: IP6777)\n\nMODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'8"\nBUST: 32A\nWAIST: 24"\nHIPS: 34"',
  tags: [],
  msrpDollars: 324,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:09.146Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
